var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.916 20.669h-5.592L27.822.368h5.592l-3.498 20.3zM50.189.864C49.086.454 47.336 0 45.173 0c-5.523 0-9.412 2.764-9.436 6.716-.046 2.916 2.785 4.536 4.902 5.508 2.163.993 2.899 1.642 2.899 2.527-.022 1.36-1.749 1.987-3.359 1.987-2.233 0-3.429-.323-5.247-1.08l-.736-.324-.783 4.557c1.312.561 3.728 1.059 6.237 1.08 5.868 0 9.689-2.72 9.734-6.932.022-2.312-1.472-4.082-4.694-5.53-1.956-.928-3.154-1.554-3.154-2.505.023-.864 1.013-1.749 3.22-1.749 1.819-.043 3.155.367 4.167.777l.505.216.761-4.384z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2.368h4.326l4.512 20.3H63.86s-.507-2.332-.668-3.045h-7.18l-1.174 3.046H48.97l8.307-18.617C57.853.735 58.867.368 60.2.368zm-.344 7.429s-1.773 4.514-2.233 5.68h4.648c-.23-1.015-1.289-5.874-1.289-5.874l-.39-1.75c-.165.45-.403 1.07-.564 1.488-.109.283-.182.473-.172.456zM.092.368H9.09c1.22.043 2.21.41 2.531 1.706l1.955 9.327.001.003.599 2.807L19.653.368h5.913l-8.79 20.28h-5.914L5.877 3.007C4.157 2.064 2.195 1.305 0 .778l.092-.41z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.94ab00516af7605bbfeabd0a8436f3c0.svg";
export { ForwardRef as ReactComponent };